<template>
  <!-- <Affix :offset-top="76" class="tab-Affix"> -->
  <div class="tab-Affix">
    <div class="tab-box">
      <div
        v-for="(item,index) in tabconfig.tabList"
        :key="index"
        :class="{'selectTab':tabconfig.defaultValue==index}"
      >
        <span @click="tabClick(index)" class="ivu-anchor-link-title">{{item.value}}</span>
        <label></label>
      </div>
    </div>
    <!-- <Anchor
      :affix="true"
      :offset-top="tabconfig.affixNum"
      container=".main"     
      class="tab-box"
    >
      <div
        v-for="(item,index) in tabconfig.tabList"
        :key="index"
        :class="{'selectTab':tabconfig.defaultValue==index}"
      >
        <span @click="tabClick(index)" class="ivu-anchor-link-title">{{item.value}}</span>
        <label></label>
      </div>
    </Anchor>-->
  </div>
  <!-- </Affix> -->
</template>
<script>
export default {
  props: {
    tabconfig: {
      type: Object,
      default: function() {
        return { defaultValue: 0, tabList: [] };
      }
    }
  },
  methods: {
    tabClick(index) {
      let jump = document.querySelectorAll(".d_jump");
      if (jump.length > 0) {
        // 获取需要滚动的距离
        let total = jump[index].offsetTop - this.tabconfig.affixNum * 2;
        document.body.scrollTop = total;
        document.documentElement.scrollTop = total;
        window.pageYOffset = total;
        console.log('total'+total);
      }
      if (
        this.tabconfig.backFun &&
        typeof this.tabconfig.backFun === "function"
      ) {
        this.tabconfig.backFun(index);
      }
      this.tabconfig.defaultValue = index;
    },
    handleScroll(e) {
        let jump = document.querySelectorAll(".d_jump");
        if(jump[1].offsetTop<(window.screen.height+window.scrollY-this.tabconfig.affixNum))
        {
           this.tabconfig.defaultValue=1;
        }else
        {
          this.tabconfig.defaultValue=0;
        }        
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  }
};
</script>
<style lang="less" scoped>
.tab-Affix {
  width: 100%;
  .tab-box {
    width: 100%;
    background: #fff;
    display: flex;
    justify-content: space-between;
    height: 0.84rem;
    /deep/ div {
      width: 100%;
    }
    /deep/ .ivu-anchor {
      display: flex;
      background: #fff;
      .ivu-anchor-ink {
        display: none;
      }
      a {
        color: #999;
      }
    }
    .selectTab {
      font-size: 0.453333rem;
      color: #2c2c2c;
      font-weight: bold;
      label {
        display: block;
        margin-left: 43%;
        width: 15%;
        height: 0.08rem;
        background-image: linear-gradient(123deg, #fcd442 0%, #ffa82c 96%);
        border-radius: 0.0667rem;
      }
    }
    div {
      flex: 1;
      text-align: center;
      font-size: 0.4rem;
      color: #999;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Share/Tab.vue